import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';
import { namespace as bulkCostReview } from './cost-review/bulk.cost-review.reducer.metadata';
import type {
  BulkActiveModalStep,
  BulkCostReviewState,
  BulkJob,
  BulkLabelBatchGroup,
  BulkLabelPurchasingState,
  BulkState,
} from './bulk.types';
import type { RootState } from 'store/root-state';

const selectLabelProcessing = (state: BulkState): BulkLabelPurchasingState => get(state, 'labelPurchasing');
const selectLabelProcessingBatches = (state: BulkState): BulkLabelPurchasingState['batches'] =>
  get(selectLabelProcessing(state), 'batches');
const selectLabelProcessingBatchGroups = (state: BulkState): BulkLabelPurchasingState['batchGroups'] =>
  get(selectLabelProcessing(state), 'batchGroups');

export const selectJobByJobGuid = (state: BulkState, props: { jobGuid: string }): BulkJob | undefined =>
  get(state, props.jobGuid) as BulkJob | undefined;
export const selectFlowStarted = (state: BulkState): boolean => get(state, 'bulkFlowStarted');
export const selectLbsModalId = (state: BulkState): string => get(state, 'lbsModalId', '');
export const selectBatchGroupByKey = (state: BulkState, props: { batchGroupKey: string }): BulkLabelBatchGroup | undefined =>
  get(selectLabelProcessingBatchGroups(state), props.batchGroupKey);
export const selectBatchGroupIdFromBatchId = (state: BulkState, props: { batchId: string }): string | undefined =>
  get(selectLabelProcessingBatches(state), props.batchId);
export const selectPurchasePostageIsLoading = (state: BulkState): boolean => get(state, 'purchasePostageLoading');
export const selectInsurancePurchaseErrorMessage = (state: BulkState): string | undefined => get(state, 'InsurancePurchaseErrorMessage');
export const selectShipDate = (state: BulkState): string | undefined => get(state, 'shipDate');
export const selectActiveModalStep = (state: BulkState): BulkActiveModalStep => get(state, 'activeModalStep', emptyObject);
export const selectLabelProcessingError = (state: BulkState): string | undefined => get(state, 'error');
export const selectCostReview = (state: BulkState): BulkCostReviewState | undefined => state?.[bulkCostReview];

export const selectBulkActiveModalStep = (state: RootState): BulkActiveModalStep => selectActiveModalStep(get(state, 'bulk'));
export const selectBulkBatchGroupByKey = (state: RootState, props: { batchGroupKey: string }): BulkLabelBatchGroup | undefined =>
  selectBatchGroupByKey(get(state, 'bulk'), props);
export const selectBulkBatchGroupIdFromBatchId = (state: RootState, props: { batchId: string }): string | undefined =>
  selectBatchGroupIdFromBatchId(get(state, 'bulk'), props);
export const selectBulkCostReview = (state: RootState): BulkCostReviewState | undefined => selectCostReview(get(state, 'bulk'));
export const selectBulkFlowStarted = (state: RootState): boolean => selectFlowStarted(get(state, 'bulk'));
export const selectBulkInsurancePurchaseErrorMessage = (state: RootState): string | undefined =>
  selectInsurancePurchaseErrorMessage(get(state, 'bulk'));
export const selectBulkJobByJobGuid = (state: RootState, props: { jobGuid: string }): BulkJob | undefined =>
  selectJobByJobGuid(get(state, 'bulk'), props);
export const selectBulkLabelProcessingError = (state: RootState): string | undefined => selectLabelProcessingError(get(state, 'bulk'));
export const selectBulkLbsModalId = (state: RootState): string => selectLbsModalId(get(state, 'bulk'));
export const selectBulkPurchasePostageIsLoading = (state: RootState): boolean => selectPurchasePostageIsLoading(get(state, 'bulk'));
export const selectBulkShipDate = (state: RootState): string | undefined => selectShipDate(get(state, 'bulk'));
